module.exports = __webpack_public_path__ + "static/media/logo.71ff5e40.png";